import type { SkillDef, SkillKey } from "../types";
import { add } from "./add";
import { sub } from "./sub";
import { mul } from "./mul";
import { div } from "./div";
import { pct } from "./pct";
import { sq } from "./sq";
import { sqrt } from "./sqrt";
import { unit } from "./unit";
import { multi } from "./multi";

/**
 * The skill registry. Order here is display order everywhere.
 * To add a skill: create skills/<key>.ts exporting a SkillDef, add its key to
 * SkillKey in types.ts, and list it here. Existing players start it at `start`.
 */
export const SKILL_LIST: SkillDef[] = [add, sub, mul, div, pct, sq, sqrt, unit, multi];
export const SKILLS = Object.fromEntries(SKILL_LIST.map((s) => [s.key, s])) as Record<SkillKey, SkillDef>;
export const SKILL_KEYS = SKILL_LIST.map((s) => s.key);
export const isSkillKey = (k: unknown): k is SkillKey => typeof k === "string" && k in SKILLS;
